import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["alert"];
  static values = {
    duration: { type: Number, default: 5000 },
    animationDuration: { type: Number, default: 300 },
  };

  connect() {
    if (this.hasAlertTarget) {
      this.startAutoHideTimer();
      this.addKeyboardListener();
    }
  }

  disconnect() {
    this.clearAutoHideTimer();
    this.removeKeyboardListener();
  }

  startAutoHideTimer() {
    this.autoHideTimer = setTimeout(() => {
      this.close();
    }, this.durationValue);
  }

  clearAutoHideTimer() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
    }
  }

  close() {
    this.alertTarget.classList.remove("opacity-100");
    this.alertTarget.classList.add("opacity-0");

    setTimeout(() => {
      this.element.remove();
    }, this.animationDurationValue);
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  addKeyboardListener() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.boundHandleKeydown);
  }

  removeKeyboardListener() {
    document.removeEventListener("keydown", this.boundHandleKeydown);
  }
}
